import React, { useEffect, useRef } from "react";
import {
  Card,
  Modal,
  Tag,
  Typography,
  Alert,
  Button,
  Space,
  Select,
} from "antd";
import { TextField } from "@locus-taxy/neo-ui";
import { useState } from "react";
import { CheckOutlined, DeleteTwoTone } from "@ant-design/icons";
import { useSelector } from "react-redux";

const { Option } = Select;
const AddGroupModal = ({
  visible,
  setVisible,
  selectedRows,
  handleAddGroup,
}) => {
  const staticSlots = useSelector((state) => state.team.slots);

  const [remainingSlotsOptions, setRemainingSlotsOptions] =
    useState(staticSlots);
  const [data, setData] = useState({
    groupName: "",
    trips: [],
  });

  useEffect(() => {
    if (selectedRows.length > 0) {
      const editGroupTrips = selectedRows[0].trips.map((trip) => {
        return {
          ...trip,
          trip_slots: trip.trip_slots.map((element) => {
            return JSON.stringify(element);
          }),
        };
      });
      setData({
        groupName: selectedRows?.[0]?.groupName,
        trips: editGroupTrips,
      });
    } else {
      setData({
        groupName: "",
        trips: [],
      });
    }
  }, [selectedRows]);

  useEffect(() => {
    let allStaticSlots = JSON.parse(JSON.stringify(staticSlots));
    if (Array.isArray(data.trips)) {
      data.trips.forEach((trip) => {
        trip.trip_slots.forEach((element) => {
          element = typeof element === "string" ? JSON.parse(element) : element;
          allStaticSlots = allStaticSlots.filter(
            (slot) =>
              slot?.startTime !== element?.startTime ||
              slot?.endTime !== element?.endTime
          );
        });
      });
    }
    setRemainingSlotsOptions(allStaticSlots);
  }, [data.trips, staticSlots]);

  const handleCancel = () => {
    setVisible(false);
  };

  const inputRefs = useRef([]);

  // useEffect(() => {
  //   // Populate the inputRefs array with refs to each text field
  //   inputRefs.current = inputRefs.current.slice(0, data.trips.length);
  // }, [data.trips.length]);

  const handleSubmit = () => {
    handleAddGroup(data);
  };

  const handleAddTrip = () => {
    setData((prevState) => ({
      ...prevState,
      trips: [...prevState.trips, { trip_id: "", trip_slots: [] }],
    }));
  };

  const handleDeleteTrip = (index) => {
    setData((prevState) => ({
      ...prevState,
      trips: prevState.trips.filter((_, i) => i !== index),
    }));
  };

  const handleTripInputChange = (value, index, field) => {
    setData((prevState) => {
      const trips = prevState.trips.map((trip, i) => {
        if (i === index) {
          return {
            ...trip,
            [field]: value,
          };
        }
        return trip;
      });
      return { ...prevState, trips };
    });
  };

  return (
    <div key={"group"}>
      <Modal
        title={selectedRows.length ? "Edit Group" : "Create New Group"}
        open={visible}
        onCancel={handleCancel}
        width="30%"
        style={{
          top: 0,
          height: "94vh",
          minWidth: "20rem",
          right: "-34.7%",
          position: "relative",
        }}
        bodyStyle={{
          height: "83vh",
          overflowY: "auto",
          backgroundColor: "#E7E9EE",
          fontSize: "12px",
        }}
        footer={[
          <div style={{ textAlign: "right" }}>
            <Button
              key={"groupAdd"}
              onClick={handleSubmit}
              style={{
                backgroundColor: "rgb(0, 114, 245)",
                color: "white",
                marginRight: "5px",
                borderRadius: "10px",
              }}
            >
              <CheckOutlined /> Save Group
            </Button>
          </div>,
        ]}
      >
        <TextField
          icon={""}
          label="Enter Group Name"
          placeholder="Any Group Name"
          value={data.groupName}
          onChange={(newValue) => {
            setData((preState) => {
              return { ...preState, groupName: newValue };
            });
          }}
        />
        <Typography.Text>
          This field must not include any space or special characters.
        </Typography.Text>
        <Card
          style={{
            marginTop: "5px",
            backgroundColor: "#F3F4F6",
          }}
        >
          <Typography.Text>Customer Slots (Remaining)</Typography.Text>

          <div style={{ display: "flex", flexWrap: "wrap" }}>
            {remainingSlotsOptions.map((remainingSlot, index) => (
              <Tag
                key={index}
                style={{
                  backgroundColor: "#E7E9EE",
                  marginBottom: "2px",
                  marginRight: "8px",
                }}
              >
                {remainingSlot?.startTime} - {remainingSlot?.endTime}
              </Tag>
            ))}
            <Alert
              message="Orders associated with these customer slots can be allocated to any trips."
              type="warning"
              showIcon
              style={{
                marginBottom: "5px",
                marginTop: "5px",
                fontSize: "12px",
              }}
            />
          </div>
        </Card>
        {data.trips.map((trip, index) => (
          <Card
            key={index}
            style={{
              backgroundColor: "#F3F4F6",
              marginBottom: "5px",
              marginTop: "8px",
              minWidth: "250px",
              fontSize: "10px",
              position: "relative",
            }}
          >
            <Space
              direction="vertical"
              style={{ width: "100%", marginTop: "10px" }}
            >
              <Typography.Text style={{ fontSize: "12px" }}>
                Combination {index + 1}
              </Typography.Text>
              <TextField
                icon={""}
                label="Trip Id"
                placeholder="Trip Id"
                value={data?.trips?.[index]?.trip_id}
                onChange={(newValue) =>
                  handleTripInputChange(newValue, index, "trip_id")
                }
                ref={(el) => (inputRefs.current[index] = el)}
              />
              This field must not include any space or special characters.
              <Select
                mode="multiple"
                value={data?.trips?.[index]?.trip_slots}
                size="large"
                onChange={(newValue) =>
                  handleTripInputChange(newValue, index, "trip_slots")
                }
                placeholder="Select Slots"
                className="custom-select"
                style={{
                  width: "100%",
                  border: "none !important",
                  borderRadius: "0px",
                  marginBottom: "10px",
                }}
                tagRender={(props) => {
                  let { label, closable, onClose } = props;
                  label = typeof label === "string" ? JSON.parse(label) : label;
                  return label?.startTime ? (
                    <Tag
                      closable={closable}
                      onClose={onClose}
                      style={{ marginRight: 3 }}
                    >
                      {label?.startTime}-{label?.endTime}
                    </Tag>
                  ) : (
                    <Tag
                      closable={closable}
                      onClose={onClose}
                      style={{ marginRight: 3 }}
                    >
                      {label}
                    </Tag>
                  );
                }}
              >
                {remainingSlotsOptions?.map((reason, index) => (
                  <Option key={index} value={JSON.stringify(reason)}>
                    {reason?.startTime}-{reason?.endTime}
                  </Option>
                ))}
              </Select>
            </Space>
            <DeleteTwoTone
              onClick={() => handleDeleteTrip(index)}
              style={{
                position: "absolute",
                top: "4px",
                right: "4px",
                zIndex: 1,
                fontSize: "15px",
              }}
            />
          </Card>
        ))}
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Button
            style={{
              backgroundColor: "#E7E9EE",
              color: "rgb(0, 114, 245)",
              marginTop: "10px",
              border: "none",
            }}
            disabled={remainingSlotsOptions.length === 0}
            onClick={handleAddTrip}
          >
            <strong>+ ADD ANOTHER TRIP</strong>
          </Button>
        </div>
      </Modal>
    </div>
  );
};

export default AddGroupModal;
